import { Box, Skeleton } from '@betty/moonlight';

function QuestSkeleton() {
  return (
    <Box width="100%" height={500} gap="space-400">
      <Skeleton height={163} />
      <Skeleton height={35} />

      <Box gap="space-400">
        <Skeleton width={150} height={20} />
        <Skeleton width={150} height={20} />
        <Skeleton width={150} height={20} />
      </Box>
      <Skeleton height={30} />
      <Skeleton height={40} />
      <Skeleton height={40} />
    </Box>
  );
}

export default QuestSkeleton;
